export const COMPARE_ITEM_NAME = {
  LEFT_COLUMN: 'leftColumn',
  RIGHT_COLUMN: 'rightColumn',
};
